var map = {
	"./Don.png": 1813,
	"./Karet.png": 5461,
	"./SenpaiVR.png": 5922,
	"./Shadozw.png": 3677,
	"./default-profile-large.webp": 6166,
	"./default-profile.webp": 2160,
	"./fizzi-128.png": 1821,
	"./gradient336.png": 9949,
	"./lilly-128.png": 2419,
	"./placeholder.webp": 1409,
	"./vrchat-logo.png": 4370,
	"./yaas-128.png": 4143
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2978;